<template>
    <div class="modal fade show modal-style" aria-labelledby="shareholderFilterTitle">
        <div class="modal-dialog modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                            <h1 class="mb-0">Filter</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                    <div class="row py-1 mx-auto">
                        <div class="col-12 col-sm-6 col-md-5 col-lg-5 roles-segment">
                            <label for="roleSelect" class="col-form-label">Role</label>
                            <v-select
                                id="roleSelect"
                                placeholder="Select Role"
                                v-model="selectedRole"
                                :options="companyRoles"
                                label="name"
                                :reduce="item => item.value"
                            />
                        </div>
                        <div class="col-12 col-sm-6 col-md-7 col-lg-7">
                            <label class="form-label" for="serialNo">Contact ID</label>
                            <input
                                placeholder="Please Enter Contact ID"
                                id="serialNo"
                                type="text"
                                v-model.trim="serialNo"
                                class="form-control"
                            />
                        </div>
                        <div class="col-4 d-flex align-items-center mt-1">
                            <button @click="onClickGo" class="btn btn-primary btn-block waves-effect waves-float waves-light">
                                Go
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loader v-if="loader"/>
    </div>
</template>

<script>
import { inject, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Loader from '@/components/atom/LoaderComponent'
import handleCompanyContact from '@/services/modules/companyContact'

export default {
    name: 'ShareHolderDropdownFilter',
    components: { Loader },
    props: {
        companyRoles: {
            type: Array,
            default: () => []
        }
    },
    emits: ['onSearchContact', 'onSearchByOwner'],
    setup(props, { emit }) {
        const store = useStore()
        const route = useRoute()
        const showError = inject('showError')
        const { fetchContactProfileBySerialNo } = handleCompanyContact()

        const loader = ref(false)
        const serialNo = ref('')
        const selectedRole = ref('shareholder')

        const onClickClose = () => {
            store.state.isModalOpenThree = false
        }

        const getBaseQuery = () => `?company_id=${route.params.companyId}`

        const handleEmployeeRole = async () => {
          const query = getBaseQuery() + `&serial_no=${serialNo.value}&roles=${selectedRole.value}`
          const res = await fetchContactProfileBySerialNo(query)

            if (!res.status) {
                return { error: 'No shareholders found for this employee.' }
            }

            emit('onSearchByOwner', res.data)
            onClickClose()
            return {}
        }

        const handleOtherRole = async () => {
            const query = getBaseQuery() + `&serial_no=${serialNo.value}&roles=${selectedRole.value}`
            const res = await fetchContactProfileBySerialNo(query)

            if (!res.status) {
                return { error: 'Invalid Contact ID.' }
            }

            const contact = res.data
            contact.name = contact.full_name
            emit('onSearchContact', contact)
            onClickClose()
            return {}
        }

        const onClickGo = async () => {
            if (!serialNo.value) {
                showError('Please Enter Contact ID')
                return
            }

            if (!selectedRole.value) {
                showError('Please Select a Role')
                return
            }

            loader.value = true

            const result = selectedRole.value === 'employee'
                ? await handleEmployeeRole()
                : await handleOtherRole()

            if (result.error) {
                showError(result.error)
            }

            loader.value = false
        }

        return {
            loader,
            serialNo,
            selectedRole,
            onClickClose,
            onClickGo,
        }
    }
}
</script>

<style scoped>
.modal-style {
    display: block;
    background: #1c1d1c33;
}
.roles-segment {
    margin-top: -13px;
}
</style>
